module.exports = __webpack_public_path__ + "static/media/download-app.cdca7bcf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/download-app.svg
// module id = 250
// module chunks = 0